module.exports = __webpack_public_path__ + "img/source_04.44241141.png";